import type { SVGProps } from "react";
// generated from DocIcon.svg — do not edit manually
// prettier-ignore
export default function DocIcon(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
  <path d="M14 2H4V15M14 2L20 8M14 2V8H20M20 8V15M4 15V22H12M4 15H12M20 15V22H12M20 15H12M12 15V22" stroke="currentColor"/>
</svg>);
}
